const formatCurrency = (currency, number, code = 'en') => new Intl.NumberFormat(code, { style: 'currency', currency }).format(Math.floor(number * 100) / 100)

const getCurrencySymbol = (currency, number) =>
    formatCurrency(currency, number)
        .replace(/[\d,.]/g, '')
        .trim()

const formatPercentage = (value) => {
    if (value === undefined || value === null) return ''

    const formattedNumber = value.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    if (value < 0) {
        return `-%${formattedNumber.slice(1)}`
    }
    return `%${formattedNumber}`
}

export { formatCurrency, getCurrencySymbol, formatPercentage }
